import noneImg from '../assets/teams/Noimg.png';

import teamAKikinee from '../assets/teams/a/kikine.webp'
import teamASashimi from '../assets/teams/a/sashimi.webp'
import teamAKentoobeta from '../assets/teams/a/kento.webp'
import teamAAmiya from '../assets/teams/a/amiya.webp'

import teamBBasho from '../assets/teams/b/basho818ttv.webp'
import teamBPiggy from '../assets/teams/b/piggy.webp'
import teamBRurui from '../assets/teams/b/rurui.webp'
import teamBOkasam from '../assets/teams/b/okasama.webp'

import teamCIchigo from '../assets/teams/c/ichigo.webp'
import teamCLemon from '../assets/teams/c/lemon.webp'
import teamCRaechuu from '../assets/teams/c/raechuu.webp'
import teamCZoe from '../assets/teams/c/zoe.webp'

import teamDsch from '../assets/teams/d/sch.webp'
import teamDmorinchu from '../assets/teams/d/morinchu.webp'
import teamDpasterunitoro from '../assets/teams/d/pasterunitoro.webp'
import teamDtakotako from '../assets/teams/d/takotako.webp'

import teamENemunaine from '../assets/teams/e/naine.webp'
import teamEKotomin from '../assets/teams/e/kotomin.webp'
import teamEMimi from '../assets/teams/e/mimi.webp'
import teamEKanna from '../assets/teams/e/kanna.webp'

import teamFperokichi from '../assets/teams/f/teamF_pero.webp'
import teamFpinku from '../assets/teams/f/teamF_pinku.webp'
import teamFbsod from '../assets/teams/f/teamF_BSOD.webp'
import teamFkentaro from '../assets/teams/f/teamF_kentaro.webp'

import teamGNoru from '../assets/teams/g/OtomataNoru.webp'
import teamGSatan from '../assets/teams/g/satan.webp'
import teamGAio from '../assets/teams/g/aio.webp'
import teamGRamune from '../assets/teams/g/ramune.webp'

import teamHOkayu from '../assets/teams/h/okayu.webp'
import teamHAmagami from '../assets/teams/h/amagami.webp'
import teamHPannomimi from '../assets/teams/h/pannomimi.webp'
import teamHFuuka from '../assets/teams/h/fuuka.webp'

import teamIAki from '../assets/teams/i/ameuchan_aki.webp'
import teamINini from '../assets/teams/i/nini.webp'
import teamINemuru from '../assets/teams/i/nemuru.webp'
import teamIRepuru from '../assets/teams/i/repuru.webp'

import teamJIka from '../assets/teams/j/mitsuimaika2.webp'
import teamJGamerobo from '../assets/teams/j/gamerobo.webp'
import teamJSiaki from '../assets/teams/j/siaki.webp'
import teamJGokyuukei from '../assets/teams/j/gokyuukei.webp'

import teamKYurayura from '../assets/teams/k/yura.webp'
import teamKRumin from '../assets/teams/k/rumin.webp'
import teamKMitsuki from '../assets/teams/k/mitsuki.webp'
import teamKHani from '../assets/teams/k/hani.webp'

import teamLGame from '../assets/teams/l/game.webp'
import teamLNew from '../assets/teams/l/new.webp'
import teamLTom from '../assets/teams/l/tom.webp'
import teamLOkiraku from '../assets/teams/l/okiraku.webp'

import teamNEnocinoco from '../assets/teams/n/enocinoco.webp'
import teamNKaruton from '../assets/teams/n/karuton.webp'
import teamNYakumo from '../assets/teams/n/yakumo.webp'
import teamNHikaru from '../assets/teams/n/hikanowa.webp'

import teamMKappy from '../assets/teams/m/kappy.webp'
import teamMnaokichi from '../assets/teams/m/naokichi.webp'
import teamMBoutarou from '../assets/teams/m/boutarou.webp'
import teamMMegane from '../assets/teams/m/megane.webp'

import teamOMznk from '../assets/teams/o/mznkn.webp'
import teamODaisuke from '../assets/teams/o/daisuke.webp'
import teamOSudachi from '../assets/teams/o/sdc.webp'
import teamOSynomu from '../assets/teams/o/snmsn.webp'

import teamPMiisyan from '../assets/teams/p/miisyan.webp'
import teamPHorinishi from '../assets/teams/p/horinishi.webp'
import teamPSawa from '../assets/teams/p/sawa.webp'
import teamPAnime from '../assets/teams/p/anime.webp'

import teamQTsubasan from '../assets/teams/q/tsubasan.webp'
import teamQTechimiya from '../assets/teams/q/techimiya.webp'
import teamQNari from '../assets/teams/q/nari.webp'
import teamQToichi from '../assets/teams/q/toichi.webp'

import teamRYumeno from '../assets/teams/r/yumeno.webp'
import teamRNana from '../assets/teams/r/77.webp'
import teamRItou from '../assets/teams/r/itosto.webp'
import teamRIcoro from '../assets/teams/r/icororo.webp'

import teamSWatarun from '../assets/teams/s/watarun.webp'
import teamSYoshio from '../assets/teams/s/yoshiox.webp'
import teamSJun from '../assets/teams/s/jun.webp'
import teamSKitaro from '../assets/teams/s/kitaro.webp'

import teamTOden from '../assets/teams/t/oden.webp'
import teamTNika from '../assets/teams/t/nika.webp'
import teamTKureha from '../assets/teams/t/kureha.webp'
import teamTAjipan from '../assets/teams/t/ajipan.webp'

import teamUBaka from '../assets/teams/u/baka.webp'
import teamUFeeto from '../assets/teams/u/Feeto.webp'
import teamUByte from '../assets/teams/u/Byte.webp'
import teamUBrush from '../assets/teams/u/brushi.webp'

import teamZ774 from '../assets/teams/z/bakahage.webp'
import teamZKarou from '../assets/teams/z/bakarou.webp'
import teamZMCMC from '../assets/teams/z/mcmc.webp'
import teamZOrin from '../assets/teams/z/orin.webp'

const teams = {
    'ネオNIPPON飯店': {
        index: "A",
        leader: {
            name: "ききねー",
            url: "https://www.twitch.tv/kikinene",
            img: teamAKikinee,
        },
        member: [
            {
                name: "さしみ飯店",
                url: "https://www.twitch.tv/sashimi_01c_",
                img: teamASashimi,
            },
            {
                name: "ケントゥベータ",
                url: "https://www.twitch.tv/kentoobeta",
                img: teamAKentoobeta,
            },
            {
                name: "網屋",
                url: "https://www.twitch.tv/amiya2008",
                img: teamAAmiya,
            },
        ]
    },
    '👍': {
        index: "B",
        leader: {
            name: "場所バショ",
            url: "https://www.twitch.tv/basho818ttv",
            img: teamBBasho,
            
        },
        member: [
            {
                name: "るるいﾁｬﾝ",
                url: "https://www.twitch.tv/luluiluu",
                img: teamBRurui,
            },
            {
                name: "岡様",
                url: "https://www.twitch.tv/ww_okasama_ww",
                img: teamBOkasam,
            },
            {
                name: "PiggyHoggyBoo",
                url: "https://www.twitch.tv/piggyhoggyboo",
                img: teamBPiggy,
                altFont: true,
            },
        ]
    },
    'Fruichu': {
        index: "C",
        leader: {
            name: "Ichigo",
            url: "https://www.twitch.tv/strawberry_tofu",
                img: teamCIchigo,
        },
        member: [
            {
                name: "Lemon",
                url: "https://www.twitch.tv/lemon_773",
                img: teamCLemon,
            },
            {
                name: "Rae Chuu",
                url: "https://www.twitch.tv/raechuu",
                img: teamCRaechuu,
            },
            {
                name: "Zoe",
                url: "https://www.twitch.tv/zoe_apple",
                img: teamCZoe,
            },
        ],
    },
    'シルバーチャリオッツ': {
        index: "D",
        leader: {
            name: "すっちー",
            url: "https://www.twitch.tv/schmugimaru",
                img: teamDsch,
        },
        member: [
            {
                name: "もりんちゅ",
                url: "https://www.twitch.tv/morinchuuu",
                img: teamDmorinchu,
            },
            {
                name: "パステルニトロ",
                url: "https://www.twitch.tv/v2_nitro",
                img: teamDpasterunitoro,
            },
            {
                name: "8たこたこ8",
                url: "https://www.twitch.tv/8takotako8",
                img: teamDtakotako,
            },
        ]
    },
    '東西の女たち': {
        index: "E",
        leader: {
            name: "カンナ",
            url: "https://www.twitch.tv/kannav2",
            img: teamEKanna,
        },
        member: [
            {
                name: "ことみん",
                url: "https://www.youtube.com/@kotomin128",
                img: teamEKotomin,
            },
            {
                name: "ミミ",
                url: "https://www.twitch.tv/33_laion",
                img: teamEMimi,
            },
            {
                name: "音夢ないね",
                url: "https://www.youtube.com/channel/UCRNj_X_jTv-ATVOJky-YR1A",
                img: teamENemunaine,
            },
        ]
    },
    'PEROMINATI': {
        index: "F",
        leader: {
            name: "新戸ぺろきち",
            url: "https://www.twitch.tv/perokichi_neet",
            img: teamFperokichi,
        },
        member: [
            {
                name: "pastellpinku",
                url: "https://www.twitch.tv/pastellpinku",
                img: teamFpinku,
            },
            {
                name: "BSoD",
                url: "https://www.twitch.tv/alexlarex",
                img: teamFbsod,
            },
            {
                name: "高橋健太郎",
                url: "https://www.twitch.tv/allback3880",
                img: teamFkentaro,
            },
        ]
    },
    'USEC Lv.1': {
        index: "G",
        leader: {
            name: "猫研あいお",
            url: "https://www.twitch.tv/aionekotogi",
            img: teamGAio,
        },
        member: [
            {
                name: "天使サたん",
                url: "https://www.twitch.tv/amatsukasatan",
                img: teamGSatan,
            },
            {
                name: "佐藤らむね",
                url: "https://www.twitch.tv/310ramune",
                img: teamGRamune,
            },
            {
                name: "音又のる",
                url: "https://www.twitch.tv/noru_vtuber",
                img: teamGNoru,
            },
        ]
    },
    '倍倍きゅん♡糖度MAX革命部': {
        index: "H",
        leader: {
            name: "天神 甘猫",
            url: "https://www.twitch.tv/amagami_channel",
            img: teamHAmagami,
        },
        member: [
            {
                name: "旗立ふうか",
                url: "https://www.twitch.tv/flag_fuuka",
                img: teamHFuuka,
            },
            {
                name: "パンの耳",
                url: "https://www.twitch.tv/pannomimi111",
                img: teamHPannomimi,
            },
            {
                
                name: "おかゆの日",
                url: "https://www.twitch.tv/okayunohi",
                img: teamHOkayu,
            },
        ]
    },
    'どて煮ベトベ登山部': {
        index: "I",
        leader: {
            name: "mofu_aki",
            url: "https://www.twitch.tv/mofu_aki",
            img: teamIAki,
        },
        member: [
            {
                name: "星月ねむる",
                url: "https://www.twitch.tv/nemuru_ch",
                img: teamINemuru,
            },
            {
                name: "れぷる",
                url: "https://www.twitch.tv/repuruyyy",
                img: teamIRepuru,
            },
                        {
                name: "にに",
                url: "https://www.twitch.tv/nini_yotuba",
                img: teamINini,
            },
        ]
    },
    'コーデは上下で4000円': {
        index: "J",
        leader: {
            name: "ゲームロボ",
            url: "https://www.twitch.tv/gamerobomt",
            img: teamJGamerobo,
        },
        member: [
            {
                name: "みついまいか",
                url: "https://www.twitch.tv/mitsui_maika",
                img: teamJIka,
            },
            {
                name: "ご休憩ニキ",
                url: "https://www.twitch.tv/georgehiroki",
                img: teamJGokyuukei,
            },
                        {
                name: "フタバとシアキ",
                url: "https://www.twitch.tv/fusiaki",
                img: teamJSiaki,
            },
        ]
    },
    'にじいろ団🌈': {
        index: "K",
        leader: {
            name: "ゆらゆら",
            url: "https://www.twitch.tv/yurayura_ch",
            img: teamKYurayura,
        },
        member: [
            {
                name: "月羽るみん",
                url: "https://www.twitch.tv/ru_rumiiiin",
                img: teamKRumin,
            },
            {
                name: "翠月じゅんぺー",
                url: "https://www.twitch.tv/junpe_mituki",
                img: teamKMitsuki,
            },
            {
                name: "みつばちはにちゃん",
                url: "https://www.twitch.tv/hani8chan",
                img: teamKHani,
            },
        ]
    },
    '現実頭皮': {
        index: "L",
        leader: {
            name: "tomchin777",
            url: "https://www.twitch.tv/tomchin777",
            img: teamLTom,
        },
        member: [
            {
                name: "Newsaan",
                url: "https://www.twitch.tv/newsaan",
                img: teamLNew,
            },
            {
                name: "がめです",
                url: "https://www.twitch.tv/snow___game",
                img: teamLGame,
            },
                        {
                name: "お気楽品行方正おじさん",
                url: "https://www.twitch.tv/iamoji3",
                img: teamLOkiraku,
            },
        ]
    },
    'わちゃわちゃ四銃士': {
        index: "M",
        leader: {
            name: "ウィリアムなおきち",
            url: "https://www.twitch.tv/william_naokichi",
            img: teamMnaokichi,
        },
        member: [
            {
                name: "めがねハードコア",
                url: "https://www.twitch.tv/meganehardcore",
                img: teamMMegane,
            },
            {
                name: "坊太郎",
                url: "https://www.twitch.tv/booowch",
                img: teamMBoutarou,
            },
            {
                name: "かっぴーげーむす",
                url: "https://www.twitch.tv/kappy_games",
                img: teamMKappy,
            },
        ]
    },
    'EBC Lvl.111': {
        index: "N",
        leader: {
            name: "えのきのこ",
            url: "https://www.twitch.tv/enocinoco",
            img: teamNEnocinoco,
        },
        member: [
            {
                name: "かるとん",
                url: "https://www.twitch.tv/cultn",
                img: teamNKaruton,
            },
            {
                name: "HikanowaGuild",
                url: "https://www.twitch.tv/hikanowaguild",
                img: teamNHikaru,
            },
            {
                name: "やくもらっぴー",
                url: "https://www.twitch.tv/yakumorappy",
                img: teamNYakumo,
            },
        ]
    },
    'チームボブ干し': {
        index: "O",
        leader: {
            name: "M12un03",
            url: "https://www.twitch.tv/m12un03",
            img: teamOMznk,
        },
        member: [
            {
                name: "すだち",
                url: "https://www.twitch.tv/sudachi_tcbn",
                img: teamOSudachi,
            },
            {
                name: "しのむー",
                url: "https://www.twitch.tv/synom29",
                img: teamOSynomu,
            },
            {
                name: "部屋守だいすけ",
                url: "https://www.twitch.tv/heyamori_daisuke",
                img: teamODaisuke,
            },
        ]
    },
    'MSHS': {
        index: "P",
        leader: {
            name: "みーしゃん",
            url: "https://www.twitch.tv/miiisyan",
            img: teamPMiisyan,
        },
        member: [
            {
                name: "沙羽",
                url: "https://www.twitch.tv/sawa_neko",
                img: teamPSawa,
            },
            {
                name: "堀西",
                url: "https://www.twitch.tv/horinisi_",
                img: teamPHorinishi,
            },
            {
                name: "佐藤Vあにめ",
                url: "https://www.twitch.tv/satouanime",
                img: teamPAnime,
            },
        ]
    },
    'つてとな': {
        index: "Q",
        leader: {
            name: "つばさん",
            url: "https://twitch.tv/tsubasan_games",
            img: teamQTsubasan,
        },
        member: [
            {
                name: "てちみや",
                url: "https://twitch.tv/techi38",
                img: teamQTechimiya,
            },
            {
                name: "といち",
                url: "https://twitch.tv/chi__10",
                img: teamQToichi,
            },
            {
                name: "なり。",
                url: "https://twitch.tv/nari_maru_",
                img: teamQNari,
            },
        ]
    },
        'レモネードケーキやきにくもつなべ': {
        index: "R",
        leader: {
            name: "夢乃名菓",
            url: "https://www.youtube.com/@yumeno_meika",
            img: teamRYumeno,
        },
        member: [
            {
                name: "ぽかぽかのなな",
                url: "https://www.twitch.tv/twitch_nana7",
                img: teamRNana,
            },
            {
                name: "イコロロ",
                url: "https://www.twitch.tv/icororo_0115",
                img: teamRIcoro,
            },
            {
                name: "いとうすとら",
                url: "https://www.youtube.com/@itou-chan",
                img: teamRItou,
            },
        ]
    },
        '既既独既': {
        index: "S",
        leader: {
            name: "わたるんの笑い部屋",
            url: "https://www.twitch.tv/wqtoth",
            img: teamSWatarun,
        },
        member: [
            {
                name: "きたろー",
                url: "https://www.twitch.tv/yamadakitarou",
                img: teamSKitaro,
            },
            {
                name: "じゅん10",
                url: "https://www.twitch.tv/jun_10channel",
                img: teamSJun,
            },
            {
                name: "よしおっくす",
                url: "https://www.twitch.tv/yoshiox11",
                img: teamSYoshio,
            },
        ]
    },
    'パーティーアニマルズ': {
        index: "T",
        leader: {
                name: "深瀬ニカ",
                url: "https://www.twitch.tv/2ka_2ka",
                img: teamTNika,
        },
        member: [
            {
                name: "アジパン",
                url: "https://www.twitch.tv/panda_azian",
                img: teamTAjipan,
            },
            {
            name: "猫神おでん",
            url: "https://www.twitch.tv/yutanpo_oden",
            img: teamTOden,
            },
            {
                name: "柊くれは",
                url: "https://www.twitch.tv/kureha1122",
                img: teamTKureha,
            },
        ]
    },
    'Let’s fighting love': {
        index: "U",
        leader: {
            name: "BakaMitaiAU",
            url: "https://www.twitch.tv/bakamitaiau",
            img: teamUBaka,
        },
        member: [
            {
                name: "FeetoBandito",
                url: "https://www.twitch.tv/feetobandito",
                img: teamUFeeto,
            },
            {
                name: "ByteSizedErami",
                url: "https://www.twitch.tv/bytesizederami",
                img: teamUByte,
            },
            {
                name: "BrushfireGlow",
                url: "https://www.twitch.tv/brushfireglow",
                img: teamUBrush,
            },
        ]
    },
    '勇者村のファイナルウェポン': {
        index: "Z",
        leader: {
            name: "Baka Lv.99",
            url: "https://www.twitch.tv/yuusha_orin",
            img: teamZOrin,
        },
        member: [
            {
                name: "BaKarou",
                url: "https://www.twitch.tv/karou_virae",
                img: teamZKarou,
            },
            {
                name: "BAKAHAGE",
                url: "https://www.twitch.tv/no7743",
                img: teamZ774,
            },
            {
                name: "Baka-mochi",
                url: "https://www.twitch.tv/mcmctex",
                img: teamZMCMC,
            },
        ]
    }
};

export default teams;